import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TextComponent } from './text.component';

@NgModule({
  exports: [TextComponent],
  declarations: [TextComponent],
  imports: [CommonModule],
})
export class TextModule {}
